import { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { forAbiturients } from '../../../../routs'

enum EActiveClassValue {
  class9 = '9',
  class10 = '10',
  class11 = '11',
}

interface IUseSelectClass {
  (
    classValue?: string,
    subject?: string | null
  ): {
    activeClassValue: EActiveClassValue | null
    handleSelectClass: (value: string) => void
  }
}

export const useSelectClass: IUseSelectClass = (classValue, subject) => {
  const { push, query } = useRouter()

  const activeClassValue = useMemo((): EActiveClassValue | null => {
    if (!classValue) {
      return null
    }

    return classValue as EActiveClassValue
  }, [classValue])

  const handleSelectClass = useCallback(
    (value: string) => {
      if (value === EActiveClassValue.class9) {
        if (subject) {
          push(
            stringifyUrl(`${forAbiturients.oge.path}/${subject}`, {
              set: {
                ...query,
              },
            })
          )
        } else {
          push(
            stringifyUrl(forAbiturients.oge.path, {
              set: {
                ...query,
              },
            })
          )
        }
      }

      if (value === EActiveClassValue.class10) {
        if (subject) {
          push(
            stringifyUrl(`${forAbiturients['ege-10'].path}/${subject}`, {
              set: {
                ...query,
              },
            })
          )
        } else {
          push(
            stringifyUrl(forAbiturients['ege-10'].path, {
              set: {
                ...query,
              },
            })
          )
        }
      }

      if (value === EActiveClassValue.class11) {
        if (subject) {
          push(
            stringifyUrl(`${forAbiturients.ege.path}/${subject}`, {
              set: {
                ...query,
              },
            })
          )
        } else {
          push(
            stringifyUrl(forAbiturients.ege.path, {
              set: {
                ...query,
              },
            })
          )
        }
      }
    },
    [subject, classValue, query, push]
  )

  return {
    activeClassValue,
    handleSelectClass,
  }
}
